export default { Loading: 'Carregando' };
